var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "to-create" },
    [
      _c(
        "el-aside",
        {
          staticClass: "aside-left",
          style: { height: _vm.boxHeight },
          attrs: { width: "2.80rem" }
        },
        [
          _c("p", { staticClass: "page-total" }, [
            _vm._v(
              "\n        共" + _vm._s(_vm.contractInfo.items) + "页\n        "
            ),
            _c(
              "a",
              {
                staticClass: "fr color-success cred",
                attrs: { href: "javascript: void(0)" },
                on: {
                  click: function($event) {
                    return _vm.apiMethods.FileOperController.download_down({
                      targetId: _vm.contractInfo.contractId,
                      fileType: _vm.fileType,
                      sign: _vm.contractInfo.sign,
                      ts: _vm.contractInfo.ts,
                      fix: ".pdf"
                    })
                  }
                }
              },
              [_vm._v("下载")]
            )
          ]),
          _c(
            "div",
            { staticClass: "page-con" },
            [
              _vm._l(_vm.contractInfo.items, function(i, index) {
                return [
                  _c(
                    "div",
                    {
                      key: index,
                      staticClass: "list",
                      class: _vm.currentInfo.page === i ? "active" : "",
                      on: {
                        click: function($event) {
                          return _vm.getContractDetailByNum(i)
                        }
                      }
                    },
                    [
                      _vm.contractList[i]
                        ? _c("img", { attrs: { src: _vm.contractList[i].url } })
                        : _c("img", {
                            attrs: { src: "/images/contr_default.jpg", alt: "" }
                          }),
                      _c("span", [_vm._v(_vm._s(i))])
                    ]
                  )
                ]
              })
            ],
            2
          ),
          _c("div", { staticClass: "go-Page" }, [
            _c("div", [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "bd" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "输入页码", type: "number" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleContractPageClick.apply(
                            null,
                            arguments
                          )
                        }
                      },
                      model: {
                        value: _vm.goPageNum,
                        callback: function($$v) {
                          _vm.goPageNum = $$v
                        },
                        expression: "goPageNum"
                      }
                    }),
                    _vm._v(
                      "\n              /" +
                        _vm._s(_vm.contractInfo.items) +
                        "\n            "
                    )
                  ],
                  1
                ),
                _c("a", { on: { click: _vm.handleContractPageClick } }, [
                  _vm._v("GO")
                ])
              ])
            ])
          ])
        ]
      ),
      _c(
        "el-main",
        { staticClass: "main-content", style: { height: _vm.boxHeight } },
        [
          _c("contract-view", {
            ref: "contractView",
            attrs: {
              "contract-info": _vm.currentInfo,
              page: _vm.currentInfo.page,
              items: _vm.contractInfo.items,
              scaleValue: _vm.scaleValue,
              "chapter-list": _vm.chapteList
            },
            on: {
              "update:contractInfo": function($event) {
                _vm.currentInfo = $event
              },
              "update:contract-info": function($event) {
                _vm.currentInfo = $event
              },
              "update:scaleValue": function($event) {
                _vm.scaleValue = $event
              },
              "update:scale-value": function($event) {
                _vm.scaleValue = $event
              },
              "update:chapterList": function($event) {
                _vm.chapteList = $event
              },
              "update:chapter-list": function($event) {
                _vm.chapteList = $event
              },
              "pre-page": function($event) {
                return _vm.getContractDetailByNum($event)
              },
              "next-page": function($event) {
                return _vm.getContractDetailByNum($event)
              },
              toCurrentPage: _vm.toCurrentPage
            }
          }),
          _c(
            "div",
            { ref: "accessory", staticClass: "text-center accessory-box" },
            [
              _vm.contractInfo &&
              _vm.contractInfo.items &&
              _vm.contractInfo.items > 1
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "jumpFirst",
                        on: {
                          click: function($event) {
                            return _vm.goPageAndFixed(1)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/images/btn-down.png")
                          }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "jumpLast",
                        on: {
                          click: function($event) {
                            return _vm.goPageAndFixed(_vm.contractInfo.items)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/images/btn-down.png")
                          }
                        })
                      ]
                    )
                  ]
                : _vm._e(),
              _c(
                "div",
                {
                  ref: "step4",
                  staticClass: "text-center btn",
                  on: {
                    click: function($event) {
                      _vm.accessoryShow = !_vm.accessoryShow
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-circle-plus" }),
                  _vm._v("\n          附属材料"),
                  _vm.accessoryShow
                    ? _c("i", { staticClass: "el-icon-arrow-down arrow" })
                    : _c("i", { staticClass: "el-icon-arrow-up arrow" })
                ]
              ),
              _c(
                "ul",
                {
                  staticClass: "text-left accessory-list",
                  attrs: { id: "accessoryList" }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        top: "10px",
                        left: "15px",
                        color: "rgba(0, 0, 0, 0.65)",
                        "font-size": "12px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "8px",
                          height: "8px",
                          "margin-right": "3px",
                          "vertical-align": "middle"
                        },
                        attrs: {
                          src: require("../../assets/images/x-icon.png")
                        }
                      }),
                      _vm._v("仅供参与方查阅，不用于签署")
                    ]
                  ),
                  _c(
                    "li",
                    { staticClass: "accessory-group" },
                    [
                      _vm.enclosureFiles.length
                        ? _vm._l(_vm.enclosureFiles, function(item, i) {
                            return _c(
                              "p",
                              { key: i, staticClass: "list-item" },
                              [
                                _c("span", [_vm._v(_vm._s(item.fileName))]),
                                _c("i", {
                                  staticClass: "el-icon-error del",
                                  on: {
                                    click: function($event) {
                                      return _vm.delAttatchFileNamesJson(
                                        item,
                                        i
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "title upload-accessory" }, [
                        _c("div", { staticClass: "div-upload" }, [_vm._v("+")]),
                        _c("input", {
                          staticClass: "input-upload",
                          attrs: { type: "file", name: "attatchInput" },
                          on: { change: _vm.handleAttatchFileUpload }
                        })
                      ])
                    ],
                    2
                  )
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-aside",
        {
          staticClass: "aside-right",
          style: { height: _vm.boxHeight },
          attrs: { width: "2.80rem" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "100%",
                "overflow-x": "hidden",
                "overflow-y": "auto"
              }
            },
            [
              _c(
                "div",
                { staticClass: "tp-box" },
                [
                  [
                    _c(
                      "p",
                      {
                        class: {
                          spec: true,
                          "m-title": true
                        }
                      },
                      [
                        _c("span", { staticClass: "t-span" }, [_vm._v("1")]),
                        _c(
                          "span",
                          {
                            class: { st1: true },
                            on: { click: _vm.setTplVar }
                          },
                          [_vm._v("设置模板变量")]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: { effect: "light", placement: "bottom-end" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("p", [
                                  _vm._v(
                                    "1. 设置模板变量后，使用模板时需填写设置的变量"
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    "2. 复制：在文档中其它地方需要使用该变量时，点击复制并拖拽到需要使用的位置。"
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    "3. 红色(初始的)变量可编辑，绿色(复制的)不可编辑"
                                  )
                                ])
                              ]
                            ),
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                "font-size": "16px",
                                margin: "0 10px",
                                color: "#a1a1a1",
                                cursor: "pointer"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "bc-box" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-box",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _vm._l(
                            _vm.baseComponents.concat(_vm.formatComponents),
                            function(item, i) {
                              return [
                                !_vm.$route.query.apiPdf ||
                                item.flag !== _vm.flag.SYSTEMDATE
                                  ? _c(
                                      "div",
                                      {
                                        key: i,
                                        staticClass: "drop-one",
                                        attrs: { draggable: "true" },
                                        on: {
                                          dragstart: function($event) {
                                            return _vm.dragQZStart($event, {
                                              flag: item.flag
                                            })
                                          },
                                          dragend: function($event) {
                                            return _vm.dragQZEnd($event, {
                                              flag: item.flag
                                            })
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { class: item.icon }),
                                        _c("p", [_vm._v(_vm._s(item.text))])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          )
                        ],
                        2
                      )
                    ])
                  ],
                  !_vm.APITPL
                    ? [
                        _c("div", [
                          _c(
                            "p",
                            {
                              staticClass: "m-title",
                              staticStyle: { "margin-top": "0.25rem" }
                            },
                            [
                              _c("span", { staticClass: "t-span" }, [
                                _vm._v("2")
                              ]),
                              _vm._v("拖动签署位置\n              ")
                            ]
                          ),
                          _c("div", { staticClass: "bc-box" }, [
                            _c(
                              "div",
                              _vm._l(
                                _vm.GET_addTpl_contractInfoJson.signers,
                                function(signerItem, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      signerItem.fix == 0
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "drop-one signer_drop",
                                                attrs: { draggable: "true" },
                                                on: {
                                                  dragstart: function($event) {
                                                    return _vm.dragQZStart(
                                                      $event,
                                                      {
                                                        flag:
                                                          _vm.flag
                                                            .SIGNNATUREANDSIGN,
                                                        selectSigner: signerItem
                                                      }
                                                    )
                                                  },
                                                  dragend: function($event) {
                                                    return _vm.dragQZEnd(
                                                      $event,
                                                      {
                                                        flag:
                                                          _vm.flag
                                                            .SIGNNATUREANDSIGN
                                                      }
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon-qzgz"
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "signer_name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        signerItem.signerAbc
                                                      ) + "签署位置"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            signerItem.userType == 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "drop-one signer_drop",
                                                    attrs: {
                                                      draggable: "true"
                                                    },
                                                    on: {
                                                      dragstart: function(
                                                        $event
                                                      ) {
                                                        return _vm.dragQZStart(
                                                          $event,
                                                          {
                                                            flag: _vm.flag.SIGN,
                                                            selectSigner: signerItem
                                                          }
                                                        )
                                                      },
                                                      dragend: function(
                                                        $event
                                                      ) {
                                                        return _vm.dragQZEnd(
                                                          $event,
                                                          {
                                                            flag: _vm.flag.SIGN
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon-qz"
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "signer_name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            signerItem.name
                                                          ) + "签署位置"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            signerItem.userType == 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "drop-one signer_drop",
                                                    attrs: {
                                                      draggable: "true"
                                                    },
                                                    on: {
                                                      dragstart: function(
                                                        $event
                                                      ) {
                                                        return _vm.dragQZStart(
                                                          $event,
                                                          {
                                                            flag:
                                                              _vm.flag
                                                                .SIGNNATURE,
                                                            selectSigner: signerItem
                                                          }
                                                        )
                                                      },
                                                      dragend: function(
                                                        $event
                                                      ) {
                                                        return _vm.dragQZEnd(
                                                          $event,
                                                          {
                                                            flag:
                                                              _vm.flag
                                                                .SIGNNATURE
                                                          }
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon-gz"
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "signer_name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            signerItem.name
                                                          ) + "签署位置"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm.copiedAdd.length
                    ? _c("div", [
                        _c("p", { staticClass: "copy-title" }, [
                          _c("img", {
                            attrs: {
                              src: "/images/icon/copy_icon.png",
                              alt: "已复制的变量"
                            }
                          }),
                          _vm._v(
                            "\n                已复制的变量\n              "
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "bc-box" },
                          _vm._l(_vm.copiedAdd, function(item) {
                            return _c(
                              "div",
                              {
                                key: item.copyCindex,
                                staticClass: "pointer",
                                attrs: { draggable: "true" },
                                on: {
                                  dragstart: function($event) {
                                    return _vm.dragQZStart($event, {
                                      flag: item.varType,
                                      varInfo: item
                                    })
                                  },
                                  dragend: function($event) {
                                    return _vm.dragQZEnd($event, {
                                      flag: item.varType
                                    })
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "bc-item" }, [
                                  _c("span", { staticClass: "item-sty" }, [
                                    _c("span", {
                                      staticClass: "icon-sty",
                                      class: _vm.varIcon(item.varType)
                                    }),
                                    _vm._v(
                                      "\n                          " +
                                        _vm._s(
                                          ([
                                            _vm.flag.SIGNNATURE,
                                            _vm.flag.SIGN,
                                            _vm.flag.SIGNNATUREANDSIGN
                                          ].includes(item.varType)
                                            ? item.signerAbc
                                            : item.inputId) +
                                            "（" +
                                            _vm.chapteList.filter(function(kk) {
                                              return (
                                                kk.copy &&
                                                kk.copyCindex ===
                                                  item.copyCindex
                                              )
                                            }).length +
                                            " 个）"
                                        ) +
                                        "\n                        "
                                    )
                                  ]),
                                  _c("i", {
                                    staticClass: "el-icon-circle-close pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.delCopy(item)
                                      }
                                    }
                                  })
                                ]),
                                _c("el-divider")
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          !_vm.$route.query.id
            ? _c(
                "div",
                { staticClass: "bb-box" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "danger-btn",
                      attrs: { type: "danger" },
                      on: { click: _vm.publishTpl }
                    },
                    [_vm._v("立即发布")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        "margin-top": "0.15rem"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "default-btn",
                          on: { click: _vm.preStep }
                        },
                        [_vm._v("上一步")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$route.query.id
            ? [
                +_vm.GET_addTpl_tplData.status === 1
                  ? _c(
                      "div",
                      { staticClass: "bb-box" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "danger-btn",
                            attrs: { type: "danger" },
                            on: { click: _vm.submitConfirmCG }
                          },
                          [_vm._v("确认提交")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                              "margin-top": "0.15rem"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "default-btn",
                                on: { click: _vm.preStep }
                              },
                              [_vm._v("上一步")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "bb-box" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "danger-btn",
                            attrs: { type: "danger" },
                            on: { click: _vm.submitConfirm }
                          },
                          [_vm._v("确认提交")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center",
                              "margin-top": "0.15rem"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "default-btn",
                                staticStyle: { width: "100%" },
                                on: { click: _vm.preStep }
                              },
                              [_vm._v("上一步")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-myDialog",
          attrs: {
            title: "提示",
            visible: _vm.tipsDialogVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.tipsDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con" }, [
            _c("p", { staticStyle: { "margin-top": "40px" } }, [
              _c("span", { staticClass: "el-icon-warning" }),
              _vm._v("当前内容还未保存，确认退出编辑？\n        ")
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      ;(_vm.tipsDialogVisible = false), (_vm.sureEdit = false)
                    }
                  }
                },
                [_vm._v("继续填写")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v("仍然退出")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "com-myDialog",
          attrs: {
            title: "模板发起成功",
            visible: _vm.fqDialogVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.fqDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "con" }, [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-weight": "normal",
                  "margin-top": "30px",
                  "text-align": "left",
                  "font-size": "16px",
                  "box-sizing": "border-box",
                  "padding-left": "28px"
                }
              },
              [
                _c("span", { staticClass: "el-icon-success" }),
                _vm._v("模板发起成功\n        ")
              ]
            ),
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "rgba(41, 2, 2, 0.65)"
                }
              },
              [
                _vm._v(
                  "\n          当前模板为停用状态，启用后授权人才可使用该模板！\n        "
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "94px" },
                  on: {
                    click: function() {
                      ;(_vm.fqDialogVisible = false),
                        _vm.$router.push({
                          path: "/console/template"
                        })
                    }
                  }
                },
                [_vm._v("\n          返回模板管理\n        ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "94px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.fqDialogVisible = false
                    }
                  }
                },
                [_vm._v("立即启用")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-048d1348", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048d1348","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/advancedVersion/setVariable.vue
// module id = NtGy
// module chunks = 21